import { connect } from "react-redux";

import { requestDailyStatistics, filterDataCompressorsLeistungsaufnahme } from "../model/util/DailyValues";
import SpezifischeLeistungsaufnahmeTabelle from "./SpezifischeLeistungsaufnahmeTabelle";

export default connect(state => ({
	model: filterDataCompressorsLeistungsaufnahme(state.charts.daily_values.spezifische_leistungsaufnahme, state.ablauf.compressors),
	timespan: state.charts.daily_values.timespan,
	rtc: state.rtc,
	compressors: state.ablauf.compressors,
	units: state.units
}), dispatch => ({
	refresh: timespan => {
		requestDailyStatistics("spezifische_leistungsaufnahme",
			timespan.from_ms, timespan.until_ms, dispatch);
	}	
}))(SpezifischeLeistungsaufnahmeTabelle);
